<template>
  <div v-if="hasAccessUser">
    <breadcrumb :crumbs="crumbs"></breadcrumb>
    <form class="ls-form" @submit.prevent="validateBeforeSubmit" v-if="!formSubmitted">
      <div class="ls-clearfix ls-md-margin-bottom"></div>
      <div class="row">
        <div class="col-md-4">
          <h3 class="ls-title-4">{{ $t('access_users.messages.access_user') }}</h3>
          <p>{{ $t('access_users.messages.access_users_info') }}</p>
        </div>
        <div class="col-md-8">
          <div class="row">
            <label class="ls-label col-md-5" :class="{'ls-error': errors.has($t('access_users.attributes.name')) }">
              <span class="ls-label-text">{{ $t('access_users.attributes.name') }}</span>
              <input
                type="text"
                maxlength="50"
                v-model="accessUser.name"
                v-validate="'required'"
                :name="$t('access_users.attributes.name')">
              <small class="ls-help-message" v-show="errors.has($t('access_users.attributes.name'))">{{ errors.first($t('access_users.attributes.name')) }}</small>
            </label>
          </div>
          <div class="row">
            <label class="ls-label col-md-5" :class="{'ls-error': errors.has($t('access_users.attributes.email')) }">
              <span class="ls-label-text">{{ $t('access_users.attributes.email') }}</span>
              <input
                type="text"
                maxlength="50"
                v-model="accessUser.email"
                v-validate="'required'"
                :name="$t('access_users.attributes.email')">
              <small class="ls-help-message" v-show="errors.has($t('access_users.attributes.email'))">{{ errors.first($t('access_users.attributes.email')) }}</small>
            </label>
          </div>
          <div class="row">
            <label class="ls-label col-md-5" :class="{'ls-error': errors.has($t('access_users.attributes.new_password')) }">
              <span class="ls-label-text">{{ $t('access_users.attributes.new_password') }}</span>
              <input
                type="password"
                maxlength="50"
                v-model="accessUser.password"
                autocomplete="new-password"
                v-validate="'required|min:6'"
                :name="$t('access_users.attributes.new_password')">
              <small class="ls-help-message" v-show="errors.has($t('access_users.attributes.new_password'))">{{ errors.first($t('access_users.attributes.new_password')) }}</small>
            </label>
          </div>
        </div>
        <div class="ls-clearfix"></div>
        <div class="col-md-12">
          <div class="row">
            <div class="ls-actions-btn">
              <div class="ls-float-right">
                <router-link :to="{ name: 'users'}" class="ls-btn" :title="$t('application.button.cancel')">{{ $t('application.button.cancel') }}</router-link>
                <button type="submit" v-bind:disabled="this.errors.any()" class="ls-btn-primary" >{{ $t('application.button.save') }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import Breadcrumb from 'src/app/components/shareds/Breadcrumb'

  export default {
    name: 'EditAccessUser',
    components: { Breadcrumb },
    data () {
      return {
        formSubmitted: false,
        editObjects: { show: false },
        crumbs: {
          'ico': 'ls-ico-edit-admin',
          'section': '',
          'paths': {
            0: {
              'title': this.$t('access_users.main.title'),
              'path': '/users'
            },
            1: {
              'title': this.$t('plans.edit.edit'),
              'path': ''
            }
          }
        },
        originalPrice: '',
        loading: true
      }
    },
    mounted () {
      this.getAccessUser()
    },
    computed: {
      ...mapGetters(['accessUser']),
      hasAccessUser () {
        return this.accessUser
      }
    },
    methods: {
      ...mapMutations(['setAccessUser']),
      ...mapActions(['loadAccessUser', 'editAccessUser']),
      getAccessUser () {
        this.loadAccessUser(this.$route.params.id).then()
      },
      validateBeforeSubmit () {
        this.$validator.validateAll().then(success => {
          if (!success) {
            return
          }
          this.updateResource()
        })
      },
      updateResource () {
        var self = this
        this.editAccessUser(this.accessUser)
        .then(function (response) {
          self.$router.push('/users')
        })
      }
    }
  }
</script>
<style lang="scss">
  .ls-label .ls-label-text + p {
    font-size: 13px;
  }
  .ls-label .ls-label-text {
    font-size: 13px;
  }
</style>



// WEBPACK FOOTER //
// Edit.vue?275ecd0c